<template>
    <a-modal width="75%" title="资金使用情况表" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
        <template #footer>
            <a-button key="back" @click="onClose">取消</a-button>
            <a-button key="submit" type="primary" :loading="confirmLoading" @click="onSubmitA">保存</a-button>
        </template>
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id" />
                </a-form-item>
                <a-form-item label="firstReviewer" name="firstReviewer">
                    <a-input v-model:value="form.firstReviewer" />
                </a-form-item>
                <a-form-item label="secondReviewer" name="secondReviewer">
                    <a-input v-model:value="form.secondReviewer" />
                </a-form-item>
                <a-form-item label="isSubmit" name="isSubmit">
                    <a-input v-model:value="form.isSubmit" />
                </a-form-item>
                <a-form-item label="auditStatus" name="auditStatus">
                    <a-input v-model:value="form.auditStatus" />
                </a-form-item>
                <a-form-item label="firstAuditStatus" name="firstAuditStatus">
                    <a-input v-model:value="form.firstAuditStatus" />
                </a-form-item>
                <a-form-item label="secondAuditStatus" name="secondAuditStatus">
                    <a-input v-model:value="form.secondAuditStatus" />
                </a-form-item>
                <a-form-item label="year" name="year">
                    <a-input v-model:value="form.year" />
                </a-form-item>
            </div>
            <div>
                <div class="title-01">1、项目基本信息</div>
                <a-row :gutter="[24, 8]">
                    <a-col :span="12">
                        <a-form-item label="企业名称" name="companyName">
                            <a-input disabled  v-model:value="form.companyName" placeholder="请输入" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="项目名称" name="subsidyType">
                            <DictSelect :disabled="true" v-model:value="form.subsidyType" :dict-name="'FundTrackingSubsidyType'" placeholder="请选择" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="项目编号" name="projectNumber">
                            <a-input v-model:value="form.projectNumber" placeholder="请输入" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="申请类别" name="applicationType">
                            <a-input v-model:value="form.applicationType" placeholder="请输入" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="补助时间" name="subsidyTime">
                            <DatePicker style="width: 100%" v-model:value="form.subsidyTime" :format="dateFormat.DATE_DAY"
                                        :showTime="false" placeholder="请填写到账时间"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="资助金额（单位：万元）" name="amountApplied">
                            <a-inputNumber :disabled="true" style="width: 100%" v-model:value="form.amountApplied" placeholder="请输入" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="企业负责人" name="companyRespon">
                            <a-input :disabled="true" v-model:value="form.companyRespon" placeholder="请输入" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item  label="联系电话" name="companyPhone">
                            <a-input :disabled="true" v-model:value="form.companyPhone" placeholder="请输入" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="项目负责人" name="projectRespon">
                            <a-input v-model:value="form.projectRespon" placeholder="请输入" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="联系电话" name="projectPhone">
                            <a-input v-model:value="form.projectPhone" placeholder="请输入" />
                        </a-form-item>
                    </a-col>
                </a-row>
            </div>
<!--            <div>-->
<!--                <div class="title-01" style="margin:20px 0 10px 0;">2、项目总体执行情况（每个月项目进展情况）</div>-->
<!--                <a-row :gutter="[24, 8]">-->
<!--                    <a-col :span="24">-->
<!--                        <a-form-item label="项目总体执行情况" name="projectExecution">-->
<!--                            <a-textarea-->
<!--                                v-model:value="form.projectExecution"-->
<!--                                placeholder="请输入项目总体执行情况"-->
<!--                                :auto-size="{ minRows: 2, maxRows: 5 }"-->
<!--                            />-->
<!--                        </a-form-item>-->
<!--                    </a-col>-->
<!--                </a-row>-->
<!--            </div>-->
            <div>
                <div class="title-01" style="margin:20px 0 10px 0;">2、高新区奖励资金支出情况
                    <a-popover  placement="rightTop">
                        <template #content>
                            <div style="width: 400px;">
                                主要包括：企业购买服务所需经费已获得各级财政科技资金资助的活动；按照法律法规或者强制性标准要求必须开展的强制监测和法定检测活动；
                                质量管理体系等认证、商标服务、财务审计、企业上市辅导等服务；一般性的市场数据分析、商务法律咨询、技术培训和技术中介服务；
                                工程项目等非研发类项目可行性报告，高新技术企业、科技型（创新型）中小企业认定咨询等服务。
                            </div>
                        </template>
                        <span>
                            <img style="width: 18px;height: 17px;margin-bottom: 3px;" src="../../../../../assets/img/gantanhao.png" alt="">
                            奖励资金不能用于与科技创新无关的服务</span>
                    </a-popover>
                  </div>
                <a-row :gutter="[24, 8]">
<!--                    <a-col :span="12">-->
<!--                        <a-form-item label="总投资" name="amountTotal">-->
<!--                            <a-inputNumber style="width: 100%" v-model:value="form.amountTotal" placeholder="请输入" />-->
<!--                        </a-form-item>-->
<!--                    </a-col>-->
<!--                    <a-col :span="12">-->
<!--                        <a-form-item label="自筹" name="amountSince">-->
<!--                            <a-inputNumber style="width: 100%" v-model:value="form.amountSince" placeholder="请输入" />-->
<!--                        </a-form-item>-->
<!--                    </a-col>-->
<!--                    <a-col :span="12">-->
<!--                        <a-form-item label="贷款" name="amountLoan">-->
<!--                            <a-inputNumber style="width: 100%" v-model:value="form.amountLoan" placeholder="请输入" />-->
<!--                        </a-form-item>-->
<!--                    </a-col>-->
<!--                    <a-col :span="12">-->
<!--                        <a-form-item label="科技资金资助金额" name="amountApplied">-->
<!--                            <a-inputNumber disabled="true" style="width: 100%" v-model:value="form.amountApplied" placeholder="请输入" />-->
<!--                        </a-form-item>-->
<!--                    </a-col>-->
<!--                    <a-col :span="12">-->
<!--                        <a-form-item label="政府其他拨款" name="amountGovernment">-->
<!--                            <a-inputNumber style="width: 100%" v-model:value="form.amountGovernment" placeholder="请输入" />-->
<!--                        </a-form-item>-->
<!--                    </a-col>-->
<!--                    <a-col :span="12">-->
<!--                        <a-form-item label="其他" name="amountOther">-->
<!--                            <a-inputNumber style="width: 100%" v-model:value="form.amountOther" placeholder="请输入" />-->
<!--                        </a-form-item>-->
<!--                    </a-col>-->
                    <a-col :span="24">
                        <a-form-item name="enterpriseFundExpenditureList">
<!--                            <template #label>-->
<!--                                高新区奖励资金支出情况-->
<!--                            </template>-->
                            <a-button type="primary" @click="handleAdd">添加</a-button>
                            <div style="color:#ff4d4f;margin:6px 0;">企业按要求点击上传相关文件（记账凭证、银行回单、发票、合同等印证材料。注意奖励资金要使用在科技创新领域）</div>
                            <a-table :columns="columns" size="large" :data-source="form.enterpriseFundExpenditureList" bordered :pagination="false">

                                <template #customTitle1>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span> 使用范围
                                    </div>
                                </template>
                                <template #customTitle2>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span> 供货商名称
                                    </div>
                                </template>
                                <template #customTitle3>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span> 金额（万元）
                                    </div>
                                </template>
                                <template #customTitle6>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span> 印证资料
                                        <p style="color: red;font-size: 10px">记账凭证/银行回单/发票/合同等</p>
                                    </div>
                                </template>
                                <template #customTitle4>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span>
                                        备注
                                    </div>
                                </template>
                                <template #amount="{ record }">
                                    <a-input  placeholder="请输入金额" v-model:value="record.amount"/>
                                </template>
                                <template #scopeOfUse="{ record }">
                                    <dict-select  :dict-name="'Scope_of_use'" v-model:value="record.scopeOfUse" placeholder="请选择使用范围"></dict-select>
                                </template>
                                <template #supplyUnit="{ record }">
                                    <a-input  placeholder="请输入供货商名称" v-model:value="record.supplyUnit"/>
                                </template>
                                <template #otherFile="{ record }">
                                    <div>
                                        <file-upload style="margin-bottom: 5px;"
                                                     v-model:value="record.expenditureFile" :size="800" :is-pdf="true" names="印证资料.PDF"/>
                                    </div>
                                </template>
                                <template #remark="{ record }" >
                                    <a-input  placeholder="请输入具体的使用范围" v-model:value="record.remark"/>
                                </template>
                                <template #action="{ record }">
                                    <div class="table-row-operations">
                                        <a style="color:red;" @click="deleteLine(record.sortNum)">删除</a>
                                    </div>
                                </template>
                                <span>
                    <a-popconfirm title="确定要删除吗?" @confirm="deleteLine(record.sortNum)">
                      <a>删除</a>
                    </a-popconfirm>
                  </span>
                            </a-table>
                        </a-form-item>
                    </a-col>
                </a-row>
            </div>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
<!--    <a-modal v-model:visible="isAllowVisible" :closable="false" :maskClosable="false">-->
<!--        <template #footer>-->
<!--            <div>-->
<!--                <a-button type="primary" @click="handleOk">去填报</a-button>-->
<!--            </div>-->
<!--        </template>-->
<!--        <h3>{{ form.year }}年对应的企业积分制未填报！</h3>-->
<!--    </a-modal>-->
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin, dictMixin } from "@/mixins";
import { sys_policy, sys_fundsTracking } from "@/api/policyService";
import DictSelect from "@/components/other/DictSelect";
import { policy, dateFormat } from "@/config/variableConfig";
import { message } from "ant-design-vue";
import { ls } from "@/utils/util";
import { file_service } from "@/api/adminService";
import axios from "axios";
import DatePicker from "@/components/form/datePicker/DatePicker.vue";

const columns = [
    {title: "序号", dataIndex: "sortNum", key: "sortNum" },
    {dataIndex: "scopeOfUse", width: 220, slots: {title: 'customTitle1',customRender: "scopeOfUse"}},
    {dataIndex: "supplyUnit", slots: {title: 'customTitle2',customRender: "supplyUnit"}},
    {dataIndex: "amount",slots: {title: 'customTitle3',customRender: "amount"}},
    {
        dataIndex: 'otherFile',
        width: 100,
        slots: {title: 'customTitle6', customRender: 'otherFile'}
    },
    { dataIndex: "remark", width: 220, slots: {title: 'customTitle4',customRender: "remark"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {title: 'customTitle5',customRender: "action"}},
];
export default {
    name: "UserModal",
    components: { DatePicker, DictSelect },
    mixins: [formMixin, dictMixin],
    data() {
        return {
            obs: false,
            dictNames: 'FundTrackingSubsidyType,Scope_of_use',
            columns,
            policy,
            dateFormat,
            isAllowVisible: false,
            form: {
                id: null,
                enterpriseFundExpenditureList: []
            },
            editableData: {},
            rules: {
                companyName:[dataCheck.required({})],
                subsidyTime:[dataCheck.required({})],
                applicationType:[dataCheck.required({})],
                projectNumber:[dataCheck.required({})],
                companyCode:[],
                amountApplied:[dataCheck.required({ type: 'number' })],
                companyRespon:[],
                companyPhone:[],
                projectRespon:[dataCheck.required({})],
                projectPhone:[dataCheck.mobile_phone, dataCheck.required({})],
                projectExecution:[dataCheck.required({})],
                amountTotal:[dataCheck.required({ type: 'number' })],
                amountSince:[dataCheck.required({ type: 'number' })],
                amountLoan:[dataCheck.required({ type: 'number' })],
                amountGovernment:[dataCheck.required({ type: 'number' })],
                amountOther:[dataCheck.required({ type: 'number' })],
                id: [],
                fundId:[],
                year:[],
                subsidyType:[],
                firstReviewer: [],
                secondReviewer: [],
                enterpriseFundExpenditureList: [dataCheck.required({ type: 'array' })],
                isSubmit: [],
                auditStatus: [],
                firstAuditStatus: [],
                secondAuditStatus: [],
            },
            submitUrl: sys_fundsTracking.saveupdate,
            submitType: 'json'
        }
    },
    methods: {
        getIsAllowData(value) {
            this.getAction({
                url: sys_policy.isFillIn + value
            }).then(res => {
                if (res) {
                    this.postAction({
                        url: sys_policy.isAllow,
                        params: { cashingTypeValue: '0', year: value }
                    }).then(res => {
                        if (res.result == 'false') {
                            message.warning('不在兑现时间范围内！', this.resetForm)
                        } else {
                            this.form.firstReviewer = res.firstReviewer
                            this.form.secondReviewer = res.secondReviewer
                        }
                    })
                } else {
                    // this.isAllowVisible = true
                }
            })
        },
        handleOk() {
            this.$router.push({ path: '/sys/manage' })
        },
        resetForm() {
            this.$refs.ruleForm.resetFields('year')
        },
        getMoban() {
            if (this.form.year) {
                this.postAction({
                    url: sys_policy.getMoban,
                    params: { cashingTypeValue: '0', year: this.form.year }
                }).then(res => {
                    this.fileDowload(res)
                })
            } else {
                message.warning('请选择年份！')
            }
        },
        fileDowload(r) {
            if (r) {
                let name = r.split('|')[1];
                axios({
                    methods: 'get',
                    url: file_service.download + r,
                    responseType: 'blob',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                        Authorization: 'Bearer' + ls.get('token') || ''
                    }
                }).then(data => {
                    const blob = new Blob([data.data], { type: "application/vnd.ms-excel;charset=utf-8" });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a"); // 创建a标签
                    link.href = url;
                    link.download = decodeURIComponent(name);// 文件重命名，若无需重命名，将该行删去
                    link.click();
                    URL.revokeObjectURL(url); // 释放内存
                })
            } else {
                message.warning('请确认承诺书是否已经上传！')
            }
        },
        handleAdd() {
            const newData = {
                sortNum: this.form.enterpriseFundExpenditureList ? this.form.enterpriseFundExpenditureList.length + 1 : 1,
                amount: '',
                expenditureFile:'',
                scopeOfUse:undefined,
                supplyUnit: '',
                remark: '',
            }
            this.form.enterpriseFundExpenditureList.push(newData)
        },
        deleteLine(key) {
            this.form.enterpriseFundExpenditureList = this.form.enterpriseFundExpenditureList.filter(item => item.sortNum !== key);
        },
        changeData(record) {
            if (record.intellectualPropertyType == '1' || record.intellectualPropertyType == '3') {
                delete record.otherFile1
                delete record.otherFile2
            }
        },
        onSubmitA() {
            let remarkboolean = false;
            this.form.enterpriseFundExpenditureList.forEach(item=>{
                if(!item.remark && item.scopeOfUse !== '4'){
                    item.remark = ' '
                }
                if(!item.remark && item.scopeOfUse == '4'){
                    remarkboolean=true;
                }
            })
            if(remarkboolean){
                this.$notification.error({
                    message: "请检查，其他备注必填"
                })
                return
            }
            if(this.allValuesNotEmpty(this.form.enterpriseFundExpenditureList) === false){
                this.$notification.error({
                    message: "请检查必填项，必填项目不能为空"
                })
                return
            }
            this.form.isSubmit = 0;
            this.form.auditStatus = 0;
            this.onSubmit()
        },
        allValuesNotEmpty(data){
            const allValuesNotEmpty = data.every((obj) => {
                return Object.values(obj).every((value) => value !== "");
            })
            return allValuesNotEmpty
        },

    },
    watch: {
        visible: {
            handler(oldValue) {
                if (this.form.yearArr.length == 1) {
                    if (oldValue) {
                        this.getIsAllowData(this.form.year)
                    }
                }
            },
        }
    }
}
</script>
<style scoped lang="less">
:deep(.ant-table-body) {
    min-height: 300px;
}

:deep(.ant-table-placeholder) {
    display: none;
}
.title-01{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    span{
        font-size: 14px;
        color: #ff581e;
        font-weight: 500;
        cursor: pointer;
    }
}
</style>
